const raceGame = {
  title: "Race-to-Earn Game",
  "description.1":
    "Earn $CRACE tokens by burning $GAM as fuel. 1 $GAM = 1 $CRACE, press until all $CRACE is claimed !",

};
export default raceGame;

